import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { QuestionBase } from '../shared/question-base';
import { QuestionControlService } from '../shared/question-control.service';
import { APPCONFIG } from "../../../config";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-dynamic-form-dialog',
  templateUrl: './dynamic-form-dialog.component.html'
})
export class DynamicFormDialogComponent implements OnInit {
  @Input() title: string;
  @Input() questions: QuestionBase<any>[] = [];
  @Output() submit = new EventEmitter<any>();

  form: FormGroup;
  AppConfig: any;

  constructor(public dialog: MatDialog, private qcs: QuestionControlService) { }

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.questions);
    this.AppConfig = APPCONFIG;
  }

  onSubmit(): void {
    this.submit.emit(this.form.value);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/dynamic-form-dialog/dynamic-form-dialog.component.ts